import {useQuery} from 'react-query';
import {getBankValidationData} from './getBankValidationData';
import {IGetBankValidationDataResponse} from './types';

const useGetBankValidationData = ({
  enabled,
  loanGuid,
}: {
  enabled: boolean;
  loanGuid?: string;
}) => {
  const {data, isLoading, refetch} = useQuery<IGetBankValidationDataResponse>(
    ['get-bank-validation-data', loanGuid],
    () => getBankValidationData(loanGuid),
    {
      enabled: enabled && Boolean(loanGuid),
    },
  );
  return {data, isLoading, refetch};
};

export default useGetBankValidationData;
